import React, { useState } from "react";
import { Collapse, ListItemButton, ListItemIcon } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { List } from "@material-ui/core";

import { formatDateTodmy } from "helpers/Parsers";
import i18n from "i18n";

import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";

import styles from "./Item.module.scss";

const Item = ({
  step,
  title,
  sku,
  tagsQuantity,
  expectedUnits,
  image,
  batch,
  expiration_date,
  tags,
  allSelecteds,
  handleSelect,
  type,
  reprint
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  // Check if any tag has zone (location) information.
  const hasZone = tags && tags.some(tag => tag.zone);
  const gridLayoutClass = hasZone
    ? styles["grid-4-cols"]
    : styles["grid-3-cols"];

  // Guard: if no tags, render minimal display without collapsible table
  if (!tags || !Array.isArray(tags) || tags.length === 0) {
    return (
      <div>
        <ListItemButton className={styles["item-container"]}>
          <div className={styles["item-title-header"]}>
            <div className={styles["item-title-header-icon-name"]}>
              <ListItemIcon>
                <img src={image} alt={title} />
              </ListItemIcon>
              <div>
                <div className={styles["item-title"]}>{title}</div>
                <div className={styles["item-title-sku"]}>{sku}</div>
              </div>
            </div>
            <div>
              <div className={styles["item-quantity"]}>Tags {tagsQuantity}</div>
            </div>
          </div>
        </ListItemButton>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", display: "block" }}>
      <ListItemButton
        onClick={handleClick}
        className={styles["item-container"]}
        disableGutters
      >
        <div className={styles["item-title-header"]}>
          <div className={styles["item-title-header-icon-name"]}>
            <ListItemIcon>
              <img src={image} style={{ height: 40 }} alt={title} />
            </ListItemIcon>
            <div>
              <div className={styles["item-title"]}>{title}</div>
              <div className={styles["item-title-sku"]}>SKU {sku}</div>
            </div>
          </div>
          <div>
            <div className={styles["item-expand"]}>
              {open ? <ExpandLess /> : <ExpandMore />}
            </div>
            <div className={styles["item-quantity"]}>
              {tagsQuantity}{" "}
              <span style={{ textTransform: "capitalize" }}>
                {i18n.t("tags")}
              </span>
            </div>
          </div>
        </div>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          className={styles["item-tags-list-main"]}
        >
          {/* Apply the dynamic grid class */}
          <div
            className={`${styles["item-sub-title"]} ${
              handleSelect ? styles["withCheckbox"] : styles["noCheckbox"]
            } ${gridLayoutClass}`}
          >
            {handleSelect && <div className={styles["col-checkbox"]}></div>}
            <div className={styles["col-epc"]}>EPC</div>
            <div className={styles["col-batch"]}>{i18n.t("batch")}</div>
            <div className={styles["col-expiration-date"]}>
              {i18n.t("expiration")}
            </div>
            {hasZone && (
              <div className={styles["col-zone"]}>{i18n.t("location")}</div>
            )}
          </div>

          {tags.map((tag, idx) => {
            return (
              <div
                key={tag.rfid || tag.tag || idx}
                className={`${styles["item-tag-list"]} ${
                  !tag.zone ? styles["item-tag-list-nozone"] : ""
                } ${
                  handleSelect ? styles["withCheckbox"] : styles["noCheckbox"]
                } ${gridLayoutClass}`}
              >
                {handleSelect && (
                  <div
                    className={styles["col-checkbox"]}
                    onClick={e => {
                      e.stopPropagation();
                      handleSelect(tag);
                    }}
                  >
                    <Checkbox checked={tag.selected || allSelecteds} />
                  </div>
                )}
                <div className={styles["col-epc"]}>{tag.tag || tag.rfid}</div>
                <div className={styles["col-batch"]}>
                  {tag.batch || batch || "-"}
                </div>
                <div className={styles["col-expiration-date"]}>
                  <div>
                    {tag.expiration_date || expiration_date
                      ? formatDateTodmy(
                          new Date(
                            (tag.expiration_date || expiration_date).replace(
                              /-/g,
                              "/"
                            )
                          )
                        )
                      : "-"}
                  </div>
                </div>
                {tag.zone && (
                  <div className={styles["col-zone"]}>{tag.zone}</div>
                )}
              </div>
            );
          })}
        </List>
      </Collapse>
    </div>
  );
};

export default Item;
